import React, { useEffect, useState } from "react";
import HttpClient from "../../utils/HttpClient";
import { useNavigate } from "react-router-dom";

const HomeCard = () => {
  const [projects, setprojects] = useState("");
  const [items, setitems] = useState("");
  const [allUsersList, setAllUsersList] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchprojectsCount = async () => {
      try {
        const res = await HttpClient.requestData("project", "GET");
        if (res && res.data) {
          setprojects(res.data.length);
        }
      } catch (error) {
        console.error("Error fetching projects count:", error);
      }
    };

    const fetchitemsCount = async () => {
      try {
        const res = await HttpClient.requestData("project-item", "GET");
        if (res && res.data) {
          setitems(res.data.length);
        }
      } catch (error) {
        console.error("Error fetching items count:", error);
      }
    };

    // >>>>Fetch All Users Data<<<<
    const fetchAllUsers = async () => {
      try {
        const res = await HttpClient.requestData("user-list", "GET");
        if (res && res.data) {
          setAllUsersList(res.data.length);
        }
      } catch (error) {
        console.error("Error fetching users count:", error);
      }
    };


    fetchprojectsCount();
    fetchitemsCount();
    fetchAllUsers();
  }, []);

  return (
    <>
      <div className="HomeTop">
        <div className="row">
          {/* Total projects Count */}
          <div className="col-md-4 col-sm-6 col-12" >
            <div className="HomeCard">
              <h5 className="HomeCardHead">{projects}</h5>
              <p className="HomeCardPara">No of Projects</p>
              <hr />
              <div className="HomeCardFooter">
                <button className="HomeCardViewbtn" onClick={() => navigate("/manageproject")}>View</button>
              </div>
              <div
                className="cardIconDiv"
                style={{ backgroundColor: "rgb(236, 64, 122)" }}
              >
                <i className="fa-regular fa-user"></i>
              </div>
            </div>
          </div>

          {/* Total items Count */}
          <div className="col-md-4 col-sm-6 col-12">
            <div className="HomeCard">
              <h5 className="HomeCardHead">{items}</h5>
              <p className="HomeCardPara">No of Project Items</p>
              <hr />
              <div className="HomeCardFooter">
                <button className="HomeCardViewbtn" onClick={() => navigate("/manageprojectitems")}>View</button>
              </div>
              <div
                className="cardIconDiv"
                style={{ backgroundColor: "rgb(73, 163, 241)" }}
              >
                <i className="fa-regular fa-user"></i>
              </div>
            </div>
          </div>

          {/* Subscription Plan Count */}
          <div className="col-md-4 col-sm-6 col-12">
            <div className="HomeCard">
              <h5 className="HomeCardHead">{allUsersList}</h5>
              <p className="HomeCardPara">No of Users</p>
              <hr />
              <div className="HomeCardFooter">
                <button className="HomeCardViewbtn" onClick={() => navigate("/manageusers")}>View</button>
              </div>
              <div
                className="cardIconDiv"
                style={{ backgroundColor: "rgb(102, 187, 106)" }}
              >
                <i className="fa-regular fa-user"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HomeCard;
